// extracted by mini-css-extract-plugin
module.exports = {"ra-notification-bar":"ra-notification-bar_ra-notification-bar__ko5n6"};